import { Dropbox } from 'dropbox';
import { DROPBOX_APP_KEY } from 'constants/index'

const getToken = () => new Promise((resolve, reject) => {
    /**
     * TODO: Handle case where the user closes the popup window
     */
    /**
     * TODO: Handle case where a new auth page doesnt open if there
     * is one open. We should show a message or close the old one first.
     */
    const dbx = new Dropbox({ clientId: DROPBOX_APP_KEY });
    const authUrl = dbx.getAuthenticationUrl(`${window.location.origin}/auth_redirect`);
    const listener = function(e) {
        if (window.location.origin !== e.origin) {
            window.removeEventListener('message', listener)
            reject()
        } else {
            if (e.data && e.data.access_token) {
                window.removeEventListener('message', listener)
                resolve(e.data)
            }
        }
    };

    window.open(authUrl, 'DropboxAuthPopup', 'dialog=yes,dependent=yes,scrollbars=yes,location=yes')

    window.addEventListener('message', listener,false);
})

export default getToken;